import { NextApiResponseBody } from 'types/bolt-api/request'
import { CreateEnergyCrisisFixProductCaseRequestBody } from '@boltenergy-be/shared'

export const postEnergyCrisisFixProductCase = async (body: CreateEnergyCrisisFixProductCaseRequestBody): Promise<NextApiResponseBody> => {
  try {
    const res = await fetch(`/api/cases/energy-crisis-fix-product`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody
  } catch (error) {
    return { success: false }
  }
}
